import React from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';
import cn from 'classnames';

import FilePicker from '../../../../Chat/components/FilePicker';
import { COLORS } from '../../../../../constants/styles';
import Icon from '../../../../Icon';
import styles from './index.styl';

export function UploadDocument({
  maxSize,
  disabled,
  iconSize,
  textStyle,
  attachment,
  setAttachment,
  handleAddDocument,
  titleAddButton,
  allowedFormats,
  validFileExtensions,
}) {
  const handleError = err => {
    const errorData = {
      ...attachment,
      errors: get(err, 'errors'),
      fileError: true,
    };
    setAttachment(errorData);
  };

  const handleAttachments = file => {
    setAttachment({
      ...attachment,
      file,
    });
    handleAddDocument();
  };

  return (
    <div
      className={cn({
        [styles.disabled]: disabled,
      })}
    >
      <FilePicker
        allowedFormats={allowedFormats}
        inputFileLabel="visit-documents"
        onError={handleError}
        onFilePick={handleAttachments}
        maxSize={maxSize}
        validFileExtensions={validFileExtensions}
      >
        <div className={styles.addActionWrapper}>
          <Icon
            name="add-text"
            size={iconSize}
            style={{ fill: COLORS.bluePrimary }}
          />
          <div className={cn(styles.addButtonTitle, textStyle)}>
            {titleAddButton}
          </div>
        </div>
      </FilePicker>
    </div>
  );
}

UploadDocument.defaultProps = {
  iconSize: 16,
};

UploadDocument.propTypes = {
  maxSize: PropTypes.number,
  disabled: PropTypes.bool,
  iconSize: PropTypes.number,
  textStyle: PropTypes.string,
  attachment: PropTypes.object,
  setAttachment: PropTypes.func,
  handleAddDocument: PropTypes.func,
  titleAddButton: PropTypes.string,
  allowedFormats: PropTypes.array,
  validFileExtensions: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/UploadDocument/index.jsx